import { render } from "./ImageViewer.vue?vue&type=template&id=54bb60e0"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Winner\\Documents\\RadSystems\\PHPRad VUE Projects\\rentacar\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
